import { useQuery } from "@apollo/client";
import {
    FetchEstimatedRiValuesQuery,
    FetchEstimatedRiValuesQueryVariables,
    FetchMarketGrowthQuery,
    FetchMarketGrowthQueryVariables,
    FetchReinsurerAverageOfferAcceptanceRateQuery,
    FetchReinsurerAverageOfferAcceptanceRateQueryVariables,
    FetchReinsurerShareQuery,
    FetchReinsurerShareQueryVariables,
    FetchRenewalRiValueQuery,
    FetchRenewalRiValueQueryVariables,
    FetchUpcomingRenewalsQuery,
    FetchUpcomingRenewalsQueryVariables,
} from "graphql/queries/__generated__/rifac-premium";
import {
    fetchEstimatedRIValues,
    fetchMarketGrowth,
    fetchReinsurerAverageOfferAcceptanceRate,
    fetchReinsurerShare,
    fetchRenewalRIValue,
    fetchUpcomingRenewals,
} from "graphql/queries/rifac-premium";

export const useRenewalRIValue = () => {
  const { data, refetch, ...rest } = useQuery<
    FetchRenewalRiValueQuery,
    FetchRenewalRiValueQueryVariables
  >(fetchRenewalRIValue, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    renewalRIValue: data?.fetchRenewalRIValue || 0,
    refresh,
    ...rest,
  };
};

export const useUpcomingRenewals = () => {
  const { data, refetch, ...rest } = useQuery<
    FetchUpcomingRenewalsQuery,
    FetchUpcomingRenewalsQueryVariables
  >(fetchUpcomingRenewals, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    upcomingRenewals: data?.fetchUpcomingRenewals || 0,
    refresh,
    ...rest,
  };
};

export const useReinsurerShare = () => {
  const { data, refetch, ...rest } = useQuery<
    FetchReinsurerShareQuery,
    FetchReinsurerShareQueryVariables
  >(fetchReinsurerShare, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    reinsurerShare: data?.fetchReinsurerShare || [],
    refresh,
    ...rest,
  };
};

export const useReinsurerAverageOfferAcceptanceRate = (period: number = 7) => {
  const { data, refetch, ...rest } = useQuery<
    FetchReinsurerAverageOfferAcceptanceRateQuery,
    FetchReinsurerAverageOfferAcceptanceRateQueryVariables
  >(fetchReinsurerAverageOfferAcceptanceRate, {
    variables: { period },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    averageOfferAcceptanceRate:
      data?.fetchReinsurerAverageOfferAcceptanceRate || null,
    refresh,
    ...rest,
  };
};

export const useMarketGrowth = () => {
  const { data, refetch, ...rest } = useQuery<
    FetchMarketGrowthQuery,
    FetchMarketGrowthQueryVariables
  >(fetchMarketGrowth, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    marketGrowth: data?.fetchMarketGrowth || [],
    refresh,
    ...rest,
  };
};
  

export const useEstimatedRIValues = () => {
  const { data, refetch, ...rest } = useQuery<
    FetchEstimatedRiValuesQuery,
    FetchEstimatedRiValuesQueryVariables
  >(fetchEstimatedRIValues, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const refresh = () => refetch();

  return {
    estimatedRIValues: data?.fetchEstimatedRIValues || [],
    refresh,
    ...rest,
  };
};